























import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { BarcodeLayer } from "@/model/document2/page/surface/design/layer/barcodeLayer";

import BarcodeKeepRatioController from "./barcodeKeepRatioController/barcodeKeepRatioController.vue";
import BarcodeShowController from "./barcodeShowController/barcodeShowController.vue";

@Component({
    components: {
        BarcodeKeepRatioController,
        BarcodeShowController
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class BarcodeController extends Vue 
{
    @Prop() layer! : BarcodeLayer;

    private barcodeControllerType = "barcodeKeepRatio";

    private isActive(type)
    {
        return this.barcodeControllerType == type;
    }

    private changeType(type : string)
    {
        this.barcodeControllerType = type;
    }

    private onChangeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {   
        this.$emit("doCommand", "changeLayerProperty", {  
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private changeText()
    {
        var parameter = {};
        parameter["propertyName"] = "text";
        parameter["type"] = "string";
        parameter["currentValue"] = this.layer.text;
        this.$emit("doCommand", "sendNativeEvent", {
            message : "request_layer_property",
            parameter : parameter
        });
    }
}
